(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('fluxo-situacao', {
                parent: 'entity',
                url: '/fluxo-situacao',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Fluxo de Situações'
                },
                ncyBreadcrumb: {
                    label: 'Fluxo de Situações'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/fluxo-situacao/fluxo-situacao.html',
                        controller: 'FluxoSituacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
